<po-modal #poModalNewInventoryCount [p-hide-close]="true" [p-primary-action]="primaryAction"
    [p-secondary-action]="secondaryAction" p-title="Nova Contagem">
    <div class="po-text-center po-font-text-large po-pt-2 po-pb-2">
        <div class="po-mb-1" style="border-bottom: 1px solid #d3d3d3;">
            <b class="add-dots">{{inventoryHeader.inventoryCode }} -
                {{inventoryHeader.inventoryDescription}}</b>
        </div>
        <div [formGroup]="newInventoryCountForm">
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <p>Informe uma descrição para a <b>nova</b> contagem:</p>
                <po-input formControlName="inventoryCountDescription" [p-required]="'true'" p-placeholder="Digite algo"
                    p-type="text" [p-maxlength]="30" [ngClass]="{
                        'ng-touched ng-dirty ng-invalid': isInventoryCountFormInvalid()
                      }">
                </po-input>
                <div *ngIf="isInventoryCountFormInvalid()" class="invalid-form-text">
                    Necessário informar a descrição.
                </div>
            </div>
        </div>
    </div>
</po-modal>

<div class="po-row po-mb-1">
    <div class="po-xl-10 po-lg-10 po-md-9 po-sm-12">
        <p class="po-font-title">Contagens do Balanço</p>
    </div>
    <div class="po-xl-2 po-lg-2 po-md-2 po-sm-12 po-text-right po-mt-2">
        <po-button p-label="Filtros" p-icon="{{seeFilter ? arrowDown : funnelIcon }}"
            (p-click)="onSeeFilter()"></po-button>
    </div>
</div>
<po-widget class="po-lg-12 po-mb-1" *ngIf="seeFilter">
    <div [formGroup]="filterForm">
        <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
            <p>Situação</p>
            <po-select formControlName="inventoryCountStatusFilter" [p-options]="statusItens"
                p-placeholder="Selecione uma Situação" [p-disabled]="true">
            </po-select>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
            <p>Código da Contagem</p>
            <po-number formControlName="inventoryCountCodeFilter" p-placeholder="Digite o código da contagem de balanço"
                [p-maxlength]="20">
            </po-number>

        </div>
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <p>Descrição</p>
            <po-input formControlName="inventoryCountDescriptionFilter" p-placeholder="Digite uma descrição"
                p-type="text" [p-maxlength]="30">
            </po-input>
        </div>
        <div class="po-lg-12 po-mb-1 po-mt-3">
            <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-text-left">
                <po-button p-label="Limpar" (p-click)="cleanFilter()"></po-button>
            </div>
            <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-text-right">
                <po-button [p-disabled]="filterForm.invalid" p-label="Aplicar filtro"
                    p-icon="an an-list-magnifying-glass" (p-click)="onFilter()"></po-button>
            </div>
        </div>
    </div>
</po-widget>
<po-widget class="po-lg-12 po-mb-2 po-mt-2">
    <div class="po-row po-pt-1">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold add-2-dots"
                style="text-align: center;">{{inventoryHeader.inventoryCode }} -
                {{inventoryHeader.inventoryDescription}}</span>
        </div>
    </div>
</po-widget>
<div class="po-row po-mt-2 po-mb-5" [class.fade-in]="fadeInAnimation">
    <po-container *ngIf="inventoryCounts.length > 0" class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <app-inventory-count-card (inventoryCountSelected)="onInventoryCountSelected($event)"
            [inventoryCounts]="inventoryCounts"></app-inventory-count-card>
    </po-container>
    <po-container *ngIf="inventoryCounts.length == 0" class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center">
        <p>Nenhum item encontrado</p>
    </po-container>
</div>

<app-fixed-round-button *ngIf="showNewCountButton" [title]="'Nova contagem'" (onClick)="openModalNewInventoryCount()" />